// Phase 12 — central motion presets (Framer Motion).
// Keep durations 150-220ms; ease-out cubic-bezier.

export const EASE_OUT = [0.16, 1, 0.3, 1]; // "ease-out-expo-ish" — premium feel
export const EASE_IN_OUT = [0.4, 0, 0.2, 1];

export const pageEnter = {
  initial: { opacity: 0, y: 8 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -4 },
  transition: { duration: 0.22, ease: EASE_OUT },
};

export const modalEnter = {
  initial: { opacity: 0, scale: 0.96 },
  animate: { opacity: 1, scale: 1 },
  exit: { opacity: 0, scale: 0.98 },
  transition: { duration: 0.18, ease: EASE_OUT },
};

export const tabSwitch = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.15, ease: EASE_OUT },
};

export const listStaggerParent = {
  initial: { opacity: 1 },
  animate: { opacity: 1 },
  transition: { staggerChildren: 0.03, delayChildren: 0.04 },
};

export const listStaggerChild = {
  initial: { opacity: 0, y: 6 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.18, ease: EASE_OUT },
};

export const fadeUp = {
  initial: { opacity: 0, y: 4 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.18, ease: EASE_OUT },
};
